import { TeamDevelopmentAreaBase } from './base/team-development-area-base';

export class TeamDevelopmentArea extends TeamDevelopmentAreaBase { }